let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("dAn5k"), load("ffEVr"), load("hhss7"), load("let0D"), load("6xJuR")]).then(() => parcelRequire('6fYhs'));